import * as React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import FiltersForm from 'modules/core/lib/forms/Filters'
import hasFeature from 'modules/core/lib/hasFeature'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import WorkScheduleEmployees from 'modules/work_schedules/components/WorkScheduleEmployees'
import type { RouteContextParams } from 'modules/work_schedules/lib/RouteContextParams'
import { canAssignEmployees } from 'modules/work_schedules/lib/canAssignEmployees'
import { RedirectToWorkScheduleListPage } from 'modules/work_schedules/pages/settings/RedirectToWorkScheduleListPage'
import schedules from 'modules/work_schedules/store/collections/schedules'

const WorkScheduleEmployeePage = () => {
  const filtersForm = useLazyRef(
    () =>
      new FiltersForm({
        sortAttribute: 'first_name',
        sortDirection: 'asc',
        filterBy: 'activity___active',
      })
  ).current

  const { workSchedule, defaultPeriod } = useOutletContext<RouteContextParams>()

  const { loading } = useAsyncData(
    () => Promise.all([schedules.fetch(), contractVersions.fetch({ withCachedFetchParams: true })]),
    []
  )

  if (!hasFeature('dev_fixed_work_schedules') && defaultPeriod?.isFixed) {
    return <RedirectToWorkScheduleListPage />
  }

  return workSchedule ? (
    <AuthorizeUser authorizeFn={() => canAssignEmployees(contractVersions)}>
      <WorkScheduleEmployees
        loading={loading}
        workSchedule={workSchedule}
        filtersForm={filtersForm}
        contractVersions={contractVersions}
      >
        <Outlet />
      </WorkScheduleEmployees>
    </AuthorizeUser>
  ) : null
}

export default WorkScheduleEmployeePage
